(function ($, w, d) {
    $(d).ready(function () {
        $('[data-entity=slider]').each(function () {
            let $this = $(this), params = $this.data('params') || {}, itemHeight = 0, $items = $this.find('.item');

            params.rows = 0;
            params.prevArrow = '<span class="prev d-flex align-items-center justify-content-center"><svg><use xlink:href="#svg_arrow"></use></svg></span>';
            params.nextArrow = '<span class="next d-flex align-items-center justify-content-center"><svg><use xlink:href="#svg_arrow"></use></svg></span>';

            $this.slick(params);
        });

        let $contactMapContainer = $('#contact_map');
        if ($contactMapContainer.length) {
            ymaps.ready(function () {
                let map = new ymaps.Map("contact_map", {
                    center: [55.8, 37.8],
                    zoom: 12
                });

                myGeoObject = new ymaps.GeoObject({
                    // Описание геометрии.
                    geometry: {
                        type: "Point",
                        coordinates: [55.8, 37.8]
                    },
                    // Свойства.
                    properties: {
                        // Контент метки.
                        iconContent: 'Заводские окна'
                    }
                }, {
                    // Опции.
                    // Иконка метки будет растягиваться под размер ее содержимого.
                    preset: 'islands#blackStretchyIcon',
                    // Метку можно перемещать.
                    draggable: false
                });

                map.geoObjects.add(myGeoObject);
            });
        }
    });

    w.Application = function (params) {
        this.siteId = '';
        this.sessId = '';

        this.$modal = !1;
        this.$layer = !1;

        this.params = params;

        $(document).ready($.proxy(this.init, this));
    };

    w.Application.prototype = {
        init: function () {
            let self = this;
        },
        numberFormat: function (number, decimals, decPoint, thousandsSep) {
            number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
            var n = !isFinite(+number) ? 0 : +number;
            var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
            var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep;
            var dec = (typeof decPoint === 'undefined') ? '.' : decPoint;
            var s = '';

            var toFixedFix = function (n, prec) {
                if (('' + n).indexOf('e') === -1) {
                    return +(Math.round(n + 'e+' + prec) + 'e-' + prec)
                } else {
                    var arr = ('' + n).split('e');
                    var sig = '';
                    if (+arr[1] + prec > 0) {
                        sig = '+'
                    }
                    return (+(Math.round(+arr[0] + 'e' + sig + (+arr[1] + prec)) + 'e-' + prec)).toFixed(prec)
                }
            };

            s = (prec ? toFixedFix(n, prec).toString() : '' + Math.round(n)).split('.');
            if (s[0].length > 3) {
                s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
            }
            if ((s[1] || '').length < prec) {
                s[1] = s[1] || '';
                s[1] += new Array(prec - s[1].length + 1).join('0')
            }

            return s.join(dec)
        }
    }
})(jQuery, window, document);